import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './router'
import keycloak from "@/plugin/authentication"

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(keycloak)
Vue.config.productionTip = false

//if (!process.env.VUE_APP_DISABLE_AUTH=="true") {
  Vue.$keycloak
    .init({ onLoad: 'login-required', checkLoginIframe: false })
    .then(() => {

      /*setInterval(() =>{
        Vue.$keycloak.updateToken(70).success((refreshed)=>{
          if (refreshed) {
            console.info('Token refreshed'+ refreshed);
          } else {
            console.warn('Token not refreshed, valid for '
            + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        }).error(()=>{
          console.error('Failed to refresh token');
        });
      });*/

      new Vue({
        router,
        store,
        render: h => h(App),
      }).$mount('#app')
    })
/*} else {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}*/
